import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import ProfilePicture from "../../../components/icons/ProfilePicture";
import { FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";

const GoogleOAuthCallback = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const scopes = {
    "https://www.googleapis.com/auth/calendar": "permission to access your google calendar",
    "https://www.googleapis.com/auth/userinfo.email": "permission to read your email address",
    "https://www.googleapis.com/auth/userinfo.profile":
      "permission to read your profile information",
  };
  
  return (
    <div className="w-full min-h-screen flex flex-col justify-center items-center bg-[var(--inyc-primary)] px-kit-24 py-kit-48">
      <div className="w-full max-w-[500px]">
        <div className="text-center">
          {searchParams.get("status") === "success" ? (
            <div className="bg-[var(--inyc-primary-light)] rounded-kit-lg p-kit-48 shadow-lg border border-[var(--inyc-input-border-color)]">
              <div className="mb-kit-32">
                <h1 className="text-kit-xl font-['Primary-Bold'] text-[var(--inyc-primary-text-color)] mb-kit-8">
                  success!
                </h1>
                <p className="text-kit-md text-[var(--inyc-primary-text-color-light)] font-['Primary-Regular']">
                  your google calendar is now synced<br />with&nbsp;in—yc
                </p>
              </div>

              <div className="mb-kit-32">
                <ProfilePicture 
                  style={{
                    margin: "0 auto var(--inyc-space-16) auto",
                    width: "100px",
                    height: "100px",
                    border: "3px solid var(--inyc-secondary)",
                  }}
                  profilePicture={searchParams.get("profilepicture") || "https://lh3.googleusercontent.com/a/default-user"} 
                />
                <h2 className="text-kit-md font-['Primary-Medium'] text-[var(--inyc-primary-text-color)]">
                  {searchParams.get("name") || "Your Google Account"}
                </h2>
              </div>

              <Link 
                to="/dashboard?tab=calendar" 
                className="inline-block px-kit-32 py-kit-12 bg-[var(--inyc-secondary)] text-[var(--inyc-secondary-text-color)] text-kit-md font-['Primary-Medium'] rounded-kit-sm hover:opacity-90 transition-opacity duration-200 shadow-md"
              >
                go back to dashboard
              </Link>
            </div>
          ) : (
            searchParams.get("status") === "error" && (
              <div className="bg-[var(--inyc-primary-light)] rounded-kit-lg p-kit-48 shadow-lg border border-[var(--inyc-input-border-color)]">
                <div className="mb-kit-32">
                  <div className="flex justify-center mb-kit-24">
                    <FaExclamationTriangle size={60} className="text-danger" />
                  </div>
                  <h1 className="text-kit-xl font-['Primary-Bold'] text-[var(--inyc-primary-text-color)] mb-kit-8">
                    connection failed
                  </h1>
                </div>

                <div className="mb-kit-32">
                  {searchParams.get("message") === "missing_scopes" ? (
                    <div className="bg-danger-soft border border-danger-line text-danger p-kit-24 rounded-kit-sm text-left">
                      <div className="font-['Primary-Medium'] mb-kit-8">missing permissions:</div>
                      <div className="pl-kit-16 font-['Primary-Regular'] text-kit-sm">
                        {searchParams
                          .get("missingScopes")
                          ?.split(",")
                          .map((scope, index) => {
                            return <div key={index} className="mb-kit-4">&bull; {scopes[scope]}</div>;
                          })}
                      </div>
                    </div>
                  ) : (
                    <div className="bg-danger-soft border border-danger-line text-danger p-kit-24 rounded-kit-sm">
                      <p className="font-['Primary-Medium']">
                        failed to connect to google calendar
                      </p>
                      <p className="text-kit-sm font-['Primary-Regular'] mt-kit-8 text-danger">
                        please try again or contact support if the issue persists
                      </p>
                    </div>
                  )}
                </div>

                <Link 
                  to="/dashboard?tab=calendar" 
                  className="inline-block px-kit-32 py-kit-12 bg-[var(--inyc-secondary)] text-on-fill text-kit-md font-['Primary-Medium'] rounded-kit-sm hover:opacity-90 transition-opacity duration-200 shadow-md"
                >
                  go back to dashboard
                </Link>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default GoogleOAuthCallback;
